import { Component } from 'react'
import { isLogin } from '@/utils';
import openLogin from '@/utils/login';
import MyPrize from '@/components/MyPrize';
import Ruler from '@/components/Ruler';
import Machine from '@/components/Machine';
import qrcodeImg from '@/assets/images/qrcode.png';
import styles from './index.module.scss';
import scanRightCode from "@/assets/images/scanrightcode.png"

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ruleShow: false,
      prizeShow: false
    }
  }
  myPrize() {
    if(!isLogin()) {
      return openLogin()
    }
    this.setState({
      prizeShow: true
    })
  }
  render() {
    return (
      <div className={styles.home}>
        <div className={styles.machineWrap}>
          <div
            data-event-param="老虎机-我的奖品"
            data-event-name="老虎机-我的奖品"
            otitle="老虎机-我的奖品"
            otype="click"
            data-event-type="click"
            onClick={this.myPrize.bind(this)} className={styles.peugeot}>我的奖品</div>
          <div
            data-event-param="老虎机-活动规则"
            data-event-name="老虎机-活动规则"
            otitle="老虎机-活动规则"
            otype="click"
            data-event-type="click"
            onClick={() => this.setState({ ruleShow: true })} className={[styles.peugeot, styles.ruler].join('\x20')}>活动规则</div>
          <Machine onSeeMyPrize={() => this.myPrize()} className={styles.machineLocal} />
        </div>
        <div className={styles.wechatInfo}>
          <div className={styles.wechatLeft}>
            <span>扫码关注公众号，解锁更多福利</span>
            <p>金条、京东卡、话费....多重好礼等你来拿</p>
            <img className={styles.wechatScanLogo} src={scanRightCode} alt="扫描右侧二维码"/>
          </div>
          <img className={styles.wechatRight} src={qrcodeImg} alt="公众号" />
        </div>
        {
          this.state.prizeShow ? <MyPrize onClick={() => this.setState({ prizeShow: false })} /> : ''
        }
        {
          this.state.ruleShow ? <Ruler onClick={() => this.setState({ ruleShow: false })} /> : ''
        }
      </div>
    );
  }
}

export default App;
